import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X } from 'lucide-react';

const CookieConsent = ({ onAccept, onDecline }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (consent === null) {
      // Show banner after a short delay for better UX
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    if (onAccept) onAccept();
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
    if (onDecline) onDecline();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t-2 border-[#04539F] shadow-lg animate-slide-up">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-[#04539F] mb-2">
              🍪 We Value Your Privacy
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              We use cookies and analytics tools to understand how you use our website and improve your experience. 
              This includes tracking page visits, form submissions, and test completions. 
              <a 
                href="/privacy" 
                className="text-[#04539F] underline hover:text-[#0668C7] ml-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more in our Privacy Policy
              </a>
            </p>
          </div>
          
          <div className="flex gap-3 items-center">
            <Button
              onClick={handleDecline}
              variant="outline"
              className="border-gray-300 hover:bg-gray-50"
            >
              Decline
            </Button>
            <Button
              onClick={handleAccept}
              className="bg-[#04539F] hover:bg-[#0668C7] text-white"
            >
              Accept Cookies
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
